import { render, staticRenderFns } from "./security-check.vue?vue&type=template&id=f4b360a6&"
import script from "./security-check.vue?vue&type=script&lang=js&"
export * from "./security-check.vue?vue&type=script&lang=js&"
import style0 from "./security-check.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports